import { render, staticRenderFns } from "./tableSales.vue?vue&type=template&id=995904de&scoped=true"
import script from "./tableSales.vue?vue&type=script&lang=js"
export * from "./tableSales.vue?vue&type=script&lang=js"
import style0 from "./tableSales.vue?vue&type=style&index=0&id=995904de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995904de",
  null
  
)

export default component.exports